import { calculateCombatManeuvers } from "../../../calculations/combatManeuvers";
import { useTranslation } from "react-i18next";

const signed = (value) => (value > 0 ? `+${value}` : value);

const CombatManeuvers = ({ character, onChange }) => {
  const { t } = useTranslation();
  const characteristics = character.characteristics;
  const result = calculateCombatManeuvers(characteristics);

  const update = (key, value) =>
    onChange({
      ...character,
      characteristics: {
        ...characteristics,
        [key]: Number(value) || 0,
      },
    });

  return (
    <section className="combat-maneuvers">
      <h2>{t("sheet.combatManeuvers")}</h2>
      <div className="combat-maneuver-results">
        <div>
          <strong>{t("sheet.cmb")}</strong>
          <output aria-label={t("sheet.cmbFull")}>{signed(result.cmb)}</output>
        </div>
        <div>
          <strong>{t("sheet.cmd")}</strong>
          <output aria-label={t("sheet.cmdFull")}>{result.cmd}</output>
        </div>
      </div>
      <div className="combat-maneuver-modifiers">
        <label>
          {t("sheet.size")}
          <input
            aria-label={t("sheet.sizeModifier")}
            type="number"
            value={characteristics.combatManeuverSizeModifier ?? 0}
            onChange={(event) =>
              update("combatManeuverSizeModifier", event.target.value)
            }
          />
        </label>
        <label>
          {t("sheet.cmbExtra")}
          <input
            aria-label={t("sheet.cmbExtraFull")}
            type="number"
            value={characteristics.additionalCombatManeuverBonus ?? 0}
            onChange={(event) =>
              update("additionalCombatManeuverBonus", event.target.value)
            }
          />
        </label>
        <label>
          {t("sheet.cmdExtra")}
          <input
            aria-label={t("sheet.cmdExtraFull")}
            type="number"
            value={characteristics.additionalCombatManeuverDefense ?? 0}
            onChange={(event) =>
              update("additionalCombatManeuverDefense", event.target.value)
            }
          />
        </label>
      </div>
    </section>
  );
};

export default CombatManeuvers;
